import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFocusFrame2Line = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Focus frame",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M20.9995 8.47004V6.89286C20.9995 4.74259 19.257 3 17.1067 3H15.8496",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3 8.47004V6.89286C3 4.74259 4.74259 3 6.89286 3H8.18205",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3 15.5312V17.1084C3 19.2577 4.74259 21.0003 6.89286 21.0003H8.14994",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.9994 15.5312V17.1084C20.9994 19.2577 19.2568 21.0003 17.1066 21.0003H15.8174",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14.1995 14.3993H9.80071C8.47553 14.3993 7.40137 13.3251 7.40137 11.9999C7.40137 10.6747 8.47553 9.60156 9.80071 9.60156H14.1995C15.5247 9.60156 16.5989 10.6747 16.5989 11.9999C16.5989 13.3251 15.5247 14.3993 14.1995 14.3993Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgFocusFrame2Line;
